/* React */
import React from "react";

/* React Redux */
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/redux/store";
import { flushRedisCache } from "src/redux/thunks/redis-cache/redisCacheThunk";
import { setToastMessage } from "src/redux/features/toast-message/toastMessageSlice";

/* Components */
import PrimaryButton from "src/components/shared/buttons/primary-button/PrimaryButton";

/* Constants */
import { SuccessMessage } from "src/shared/constants/common/SuccessMessage";
import { GlobalMessageType } from "src/shared/constants/common/GlobalMessage";

/* Stylesheet */
import styles from "./DevOptions.module.scss";

/* Interfaces */
interface DevOptionsProps {
  disabled: boolean;
}

const DevOptions: React.FC<DevOptionsProps> = ({
  disabled,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <div className={styles.dev_options}>
      <PrimaryButton
        ariaLabel={"Flush cache"}
        type={"button"}
        label={"Flush cache"}
        disabled={disabled}
        onClick={() => {
          dispatch(flushRedisCache()).then(() => {
            dispatch(
              setToastMessage({
                type: GlobalMessageType.SUCCESS,
                message: SuccessMessage.FLUSH_CACHE,
                show: true,
              })
            );
          });
        }}
      />
    </div>
  );
};

export default DevOptions;
